import { registerGlobalErrorHandlers } from "./utils/globalErrorHandler";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ReactFlowProvider } from "react-flow-renderer";

import "./index.css";
import "./App.css";

import store from "./Store/Store";
import ErrorBoundary from "./componets/Common/ErrorBoundary";
import { ThreeDots } from "react-loader-spinner";

// Register global error handlers (e.g., window.onerror, unhandledrejection)
registerGlobalErrorHandlers();

// Lazy load App for performance
const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-screen">
            <ThreeDots color="#1995d2" width="50" visible={true} />
          </div>
        }
      >
        <ReactFlowProvider>
          <Provider store={store}>
            <Router>
              <App />
            </Router>
          </Provider>
        </ReactFlowProvider>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
